import React from 'react'

const HeaderComponent = ({ title }) => {
    return (
            <h1>{title}</h1>
    )
}

export default HeaderComponent
